import {Text, View} from '@react-pdf/renderer';
import {TFunction} from 'i18next';

import {LineChartReport} from './LineChartReport/LineChartReport';
import {ReportCultureFit} from './ReportCultureFIt';
import {sharedStyles} from './styles/shared-styles';
import {greenColors, orangeColors} from '../../../../../layouts/theme/designSystem';
import {PillarData, ScreeningCultureFit} from '../../../../../types/ApplicantScreeningReport';
import {SupportedLanguages} from '../../../../../types/SupportedLanguages';
import {questionCardScalesStyles} from '../../../recruiting/applicant-pdf-export/components/styles/question-card-scales-styles';

interface Props {
  t: TFunction;
  lang: SupportedLanguages;
  pillarData: PillarData[];
  cultureFit: ScreeningCultureFit;
  applicantName: string;
}

export const ReportCultureFitSection = ({t, lang, pillarData, cultureFit, applicantName}: Props) => {
  const renderLegend = () => {
    return (
      <View style={{display: 'flex', flexDirection: 'row', marginBottom: 2}} wrap={false}>
        <View style={questionCardScalesStyles.legendItem}>
          <View style={[questionCardScalesStyles.legendBar, {backgroundColor: orangeColors[100]}]} />
          <Text style={questionCardScalesStyles.legendText}>{t('applicantPdfExport.us')}</Text>
        </View>
        <View style={questionCardScalesStyles.legendItem}>
          <View style={[questionCardScalesStyles.legendBar, {backgroundColor: greenColors[100]}]} />
          <Text style={questionCardScalesStyles.legendText}>{applicantName}</Text>
        </View>
      </View>
    );
  };

  return (
    <>
      <View style={{marginBottom: '8px'}}>
        <Text style={{...sharedStyles.h2, marginBottom: 2}}>{t('applicantDashboard.matchesView.cultureFit')}</Text>
        <Text style={{...sharedStyles.body1, marginBottom: 1}}>
          {t('screeningModule.report.cultureFit.question', {
            applicantName: applicantName,
          })}
        </Text>
        <Text style={{...sharedStyles.body1, marginBottom: 1}}>
          {t('screeningModule.report.cultureFit.description')}
        </Text>
      </View>

      <View>{renderLegend()}</View>

      <View style={{display: 'flex', flexDirection: 'row', gap: 20, marginBottom: 4}}>
        <LineChartReport lang={lang} pillars={pillarData} />
        <View>
          <ReportCultureFit percentage={cultureFit.fitScore} text={t('screeningModule.report.cultureFit.overallFit')} />
          <ReportCultureFit
            percentage={cultureFit.averageCompanyEmployeeFit}
            text={t('screeningModule.report.cultureFit.avarageEmployeeFit')}
          />
          <ReportCultureFit
            percentage={cultureFit.averageCompanyApplicantFit}
            text={t('screeningModule.report.cultureFit.avarageApplicantFit')}
          />
        </View>
      </View>
    </>
  );
};
